module.exports = __webpack_public_path__ + "static/img/plus102.77a6058.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bird/plus102.png
// module id = xC7R
// module chunks = 1